export default function Footer() {
    return (
        <section id="footer">
            <a href="https://www.nutrition.gov/" target="_blank"><p>Nutrition</p></a>
        </section>
    )
}